import { z } from 'zod'

// Форма сотрудника на фронте (после маппинга snake→camel). Источник — проекция
// хаба (00-architecture § 2): username/name/email/role из claims, departments —
// набор канонических имён отделов (сотрудник может быть в ≤10), isAdmin производный
// от role, isActive — активность в хабе. Набор отделов редактируется:
// PUT /employees/{id}/departments (replace, имена доупсерживаются в справочник).
export const EmployeeSchema = z.object({
  id: z.string(),
  username: z.string(),
  name: z.string(),
  email: z.string(),
  departments: z.array(z.string()),
  role: z.string(),
  isAdmin: z.boolean(),
  isActive: z.boolean(),
})

export type Employee = z.infer<typeof EmployeeSchema>
